// Promotional links constants for all marketing channels
// These links are used to track downloads and traffic from various sources

// App Store Links
export const APP_STORE_LINKS = {
  APPLE: "https://apps.apple.com/gb/app/tigola/id6754160658",
  GOOGLE_PLAY:
    "https://play.google.com/store/apps/details?id=com.tigola.android.CustomerApp",
};

// Promotional Web Links with UTM parameters
export const PROMOTIONAL_LINKS = {
  // Web Links
  WEB_LINK: "https://www.tigola.com/app",

  // Direct & Organic
  WEBSITE: "https://tigola.com/app?src=website",

  // Social Media Organic
  FACEBOOK: "https://tigola.com/app?src=facebook",
  INSTAGRAM: "https://tigola.com/app?src=instagram",
  WHATSAPP: "https://tigola.com/app?src=whatsapp",

  // Paid Advertising
  FACEBOOK_ADS: "https://tigola.com/app?src=facebook_ads",
  INSTAGRAM_ADS: "https://tigola.com/app?src=instagram_ads",
  TIKTOK_ADS: "https://tigola.com/app?src=tiktok_ads",
  GOOGLE_ADS: "https://tigola.com/app?src=google_ads",
  GOOGLE_ORGANIC: "https://tigola.com/app?src=google_organic",
  GOOGLE_MAPS: "https://tigola.com/app?src=google_maps",
  GOOGLE_MAPS_ADS: "https://tigola.com/app?src=google_maps_ads",
  WHATSAPP_ADS: "https://tigola.com/app?src=whatsapp_ads",

  // Physical Marketing (QR Codes)
  BUSINESS_CARD: "https://tigola.com/app?src=business_card",
  SHOP_POSTER: "https://tigola.com/app?src=poster",
  CAR_DOOR_SIGN: "https://tigola.com/app?src=car_door",
  CAR_WINDOW_STICKER: "https://tigola.com/app?src=window_sticker",
  FLYERS: "https://tigola.com/app?src=flyer",
};

// Get app store link for a specific platform
export const getAppStoreLink = (platform: "ios" | "android"): string => {
  return platform === "ios"
    ? APP_STORE_LINKS.APPLE
    : APP_STORE_LINKS.GOOGLE_PLAY;
};

// Get promotional link by source
export const getPromotionalLink = (source: string): string => {
  const sourceKey = source.toUpperCase().replace(/-/g, "_");
  return (
    (PROMOTIONAL_LINKS as Record<string, string>)[sourceKey] ||
    PROMOTIONAL_LINKS.WEBSITE
  );
};

// Map source codes to promotional link objects for analytics
export const ANALYTICS_SOURCE_MAP = {
  website: {
    label: "Website Direct",
    link: PROMOTIONAL_LINKS.WEBSITE,
  },
  facebook: {
    label: "Facebook Organic",
    link: PROMOTIONAL_LINKS.FACEBOOK,
  },
  facebook_ads: {
    label: "Facebook Ads",
    link: PROMOTIONAL_LINKS.FACEBOOK_ADS,
  },
  instagram: {
    label: "Instagram Organic",
    link: PROMOTIONAL_LINKS.INSTAGRAM,
  },
  instagram_ads: {
    label: "Instagram Ads",
    link: PROMOTIONAL_LINKS.INSTAGRAM_ADS,
  },
  tiktok_ads: {
    label: "TikTok Ads",
    link: PROMOTIONAL_LINKS.TIKTOK_ADS,
  },
  google_organic: {
    label: "Google Organic",
    link: PROMOTIONAL_LINKS.GOOGLE_ORGANIC,
  },
  google_ads: {
    label: "Google Ads",
    link: PROMOTIONAL_LINKS.GOOGLE_ADS,
  },
  google_maps: {
    label: "Google Maps",
    link: PROMOTIONAL_LINKS.GOOGLE_MAPS,
  },
  google_maps_ads: {
    label: "Google Maps Ads",
    link: PROMOTIONAL_LINKS.GOOGLE_MAPS_ADS,
  },
  whatsapp: {
    label: "WhatsApp Organic",
    link: PROMOTIONAL_LINKS.WHATSAPP,
  },
  whatsapp_ads: {
    label: "WhatsApp Ads",
    link: PROMOTIONAL_LINKS.WHATSAPP_ADS,
  },
  business_card: {
    label: "Business Card QR",
    link: PROMOTIONAL_LINKS.BUSINESS_CARD,
  },
  poster: {
    label: "Shop Poster QR",
    link: PROMOTIONAL_LINKS.SHOP_POSTER,
  },
  car_door: {
    label: "Car Door Sign QR",
    link: PROMOTIONAL_LINKS.CAR_DOOR_SIGN,
  },
  window_sticker: {
    label: "Car Window Sticker",
    link: PROMOTIONAL_LINKS.CAR_WINDOW_STICKER,
  },
  flyer: {
    label: "Flyers",
    link: PROMOTIONAL_LINKS.FLYERS,
  },
};
